import { useEffect } from "react";

const BASIS = "LILASp Katalog";

/**
 * Setzt den Dokumenttitel und stellt ihn beim Verlassen zurück (Kopie aus
 * lilasprojekte). Mit mehreren offenen Reitern ist der Titel die einzige Stelle, an
 * der man sieht, welcher davon welchen Katalog zeigt.
 */
export function useTitel(titel?: string): void {
  useEffect(() => {
    const vorher = document.title;
    document.title = titel ? `${titel} · ${BASIS}` : BASIS;
    return () => {
      document.title = vorher;
    };
  }, [titel]);
}
